import { capitalizeSpanish } from "#core/functions/string"
import { Typography } from "@mui/material"
import React from "react"
const wrappedProps = (noWrap) =>
	noWrap ? { noWrap: true, sx: { overflow: "hidden", textOverflow: "ellipsis" } } : {}

export function TextTitleMain({ label, noWrap }) {
	label = capitalizeSpanish(`${label}`)
	return (
		<Typography
			variant="body1"
			fontWeight="600"
			color="text.primary"
			{...wrappedProps(noWrap)}
		>
			{label}
		</Typography>
	)
}
export function TextBodyMain({ label, children, noWrap }) {
	return (
		<Typography variant="body2" color="text.secondary" {...wrappedProps(noWrap)}>
			{label || children}
		</Typography>
	)
}
